import { ComponentProps, forwardRef } from 'react';
import cn from '../../app/utils/cn';

export type TextButtonSize = 'xs' | 'sm';

interface ITextButtonProps extends ComponentProps<'button'> {
  size?: TextButtonSize;
  underlineOnHover?: boolean;
}

const sizeClass: Record<TextButtonSize, string> = {
  xs: 'text-xs',
  sm: 'text-sm',
};

export const TextButton = forwardRef<HTMLButtonElement, ITextButtonProps>(
  (
    {
      type = 'button',
      size = 'sm',
      underlineOnHover = false,
      className,
      disabled,
      children,
      ...props
    },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={cn(
        'text-text-secondary hover:text-text-primary inline-flex items-center justify-center font-medium tracking-wide transition-colors outline-none',
        'rounded focus-visible:ring-2 focus-visible:ring-green-500/50',
        'disabled:cursor-not-allowed disabled:opacity-50',
        sizeClass[size],
        underlineOnHover && 'underline-offset-2 hover:underline',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
);

TextButton.displayName = 'TextButton';
